
<div class = "card card-container">
    <div class="card-label px-1">
        <mat-label> 
            <span translate>
                legenda
            </span>
        </mat-label>
    </div>
    <div class="list-group w-100 list">
        <span  *ngFor="let legend of legends"
            class="list-group-item box m-2"
            [ngStyle]="getGradient(legend)">
            {{legend.text | translate }}
        </span>
    </div>
</div>          



  